import React from 'react'
import AppLayout from '../../../../../layout/components/AppLayout'

function ProductListPage() {
  return (
    <AppLayout>
        <div>ProductListPage</div>
    </AppLayout>
  )
}

export default ProductListPage